<template>
  <!-- Admin-only "View as team" control. Renders nothing for normal users. -->
  <div v-if="isSuperAdmin" class="view-as-team">
    <!-- Active impersonation banner -->
    <div v-if="activeTeam" class="view-as-team__banner">
      <span class="view-as-team__label">
        Viewing as
        <strong>{{ activeTeam.name }}</strong>
        <span v-if="activeTeam.plan" class="view-as-team__plan">
          ({{ activeTeam.plan }})
        </span>
      </span>
      <button
        type="button"
        class="view-as-team__stop"
        @click="stopImpersonating"
      >
        Stop
      </button>
    </div>

    <!-- Team picker -->
    <div v-else class="view-as-team__picker">
      <input
        v-model="query"
        type="text"
        class="view-as-team__input"
        placeholder="View as team… (team name or user email)"
        @input="onQueryInput"
      />
      <ul v-if="results.length" class="view-as-team__results">
        <li
          v-for="team in results"
          :key="team.id"
          class="view-as-team__result"
          @click="startImpersonating(team)"
        >
          <span class="view-as-team__result-name">
            {{ team.name }}
            <span v-if="team.matchedEmail" class="view-as-team__result-email">
              {{ team.matchedEmail }}
            </span>
          </span>
          <span class="view-as-team__result-plan">{{ team.plan }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import EnsureCloud from "../../helpers/ensure-cloud";

export default {
  name: "ViewAsTeam",
  data() {
    return {
      query: "",
      results: [],
      searchTimer: null,
    };
  },
  computed: {
    isSuperAdmin() {
      return !!this.$store.state.user && !!this.$store.state.user.isSuperAdmin;
    },
    activeTeam() {
      return this.$store.state.impersonateTeam;
    },
  },
  methods: {
    onQueryInput() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(this.search, 250);
    },
    async search() {
      const q = this.query.trim();
      if (!q) {
        this.results = [];
        return;
      }

      const Cloud = await EnsureCloud();
      const teams = await Cloud.adminTeamsSearch({ q })
        .headers({
          Authorization: `Bearer ${this.$store.state.token}`,
        })
        .tolerate((err) => {
          console.error(err);
          return [];
        });

      this.results = Array.isArray(teams) ? teams : [];
    },
    startImpersonating(team) {
      this.$store.commit("setImpersonateTeam", {
        id: team.id,
        name: team.name,
        plan: team.plan,
      });
      // Reload so every page refetches its data as the selected team.
      window.location.reload();
    },
    stopImpersonating() {
      this.$store.commit("clearImpersonateTeam");
      window.location.reload();
    },
  },
};
</script>

<style scoped>
.view-as-team {
  position: fixed;
  bottom: 1rem;
  right: 1rem;
  z-index: 9999;
  font-size: 0.8125rem;
}

.view-as-team__banner {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background: #7c2d12;
  color: #fff;
  padding: 0.5rem 0.75rem;
  border-radius: 0.5rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
}

.view-as-team__plan {
  opacity: 0.8;
}

.view-as-team__stop {
  background: #fff;
  color: #7c2d12;
  border: none;
  border-radius: 0.375rem;
  padding: 0.25rem 0.625rem;
  font-weight: 600;
  cursor: pointer;
}

.view-as-team__picker {
  position: relative;
}

.view-as-team__input {
  width: 16rem;
  padding: 0.5rem 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 0.5rem;
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.view-as-team__results {
  position: absolute;
  bottom: 100%;
  right: 0;
  margin-bottom: 0.25rem;
  width: 16rem;
  max-height: 16rem;
  overflow-y: auto;
  list-style: none;
  padding: 0.25rem;
  margin-top: 0;
  background: #fff;
  border: 1px solid #d1d5db;
  border-radius: 0.5rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.view-as-team__result {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0.375rem 0.5rem;
  border-radius: 0.375rem;
  cursor: pointer;
}

.view-as-team__result:hover {
  background: #f3f4f6;
}

.view-as-team__result-name {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.view-as-team__result-email {
  opacity: 0.6;
  font-size: 0.75rem;
  overflow: hidden;
  text-overflow: ellipsis;
}

.view-as-team__result-plan {
  opacity: 0.6;
  font-size: 0.75rem;
}
</style>
